import { store } from "../index/terminalApp"
import { getBalance } from "./balance";
import { askForUserLogout, logoutUser } from "./verification";

export const handleIdle = () => {
  const isVerified = store.getState().user.verification?.success;
  const currentBalance = getBalance();

  if (isVerified) {
    if (currentBalance === 0) logoutUser()
    else if (currentBalance < 5) askForUserLogout()
  }
}